import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { AssessmentApi } from './client';
import { acquireToken } from '../auth/msal';

const ApiContext = createContext<AssessmentApi | null>(null);

export function ApiProvider({ children }: { children: ReactNode }) {
  const api = useMemo(
    () => new AssessmentApi(import.meta.env.VITE_API_BASE_URL ?? '', acquireToken),
    [],
  );
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): AssessmentApi {
  const api = useContext(ApiContext);
  if (!api) throw new Error('useApi must be used inside ApiProvider');
  return api;
}
